/**
 * Asset slot resolution (docs/ASSETS.md §2). Renderers never hardcode a file path; they resolve an asset
 * slot key (from `CHARACTER_SLOTS[slot].assetSlot` or `RECEIVER_ASSET_SLOT`) through this one map.
 */
import { RECEIVER_ASSET_SLOT } from '@momentum/shared';
import characterSquareUrl from './characters/character-square.svg?url';
import characterOvalUrl from './characters/character-oval.svg?url';
import characterTriangleUrl from './characters/character-triangle.svg?url';
import characterHexagonUrl from './characters/character-hexagon.svg?url';
import characterDiamondUrl from './characters/character-diamond.svg?url';
import characterCircleUrl from './characters/character-circle.svg?url';
import receiverUrl from './characters/receiver.svg?url';

const ASSET_URLS: Record<string, string> = {
  'character-square': characterSquareUrl,
  'character-oval': characterOvalUrl,
  'character-triangle': characterTriangleUrl,
  'character-hexagon': characterHexagonUrl,
  'character-diamond': characterDiamondUrl,
  'character-circle': characterCircleUrl,
  [RECEIVER_ASSET_SLOT]: receiverUrl,
};

/** Resolves an asset slot key to its SVG URL. Falls back to the receiver placeholder for an unknown slot. */
export function characterAssetUrl(assetSlot: string): string {
  return ASSET_URLS[assetSlot] ?? receiverUrl;
}
